module.exports = __webpack_public_path__ + "img/info2.ea87bbb3.png";